import BONESMidwayJavaScriptClient from 'BONESMidwayJavaScriptClient';

export class JSClient {

    constructor(props){
        this.props = props || {};
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getIdentity = this.getIdentity.bind(this);
        new BONESMidwayJavaScriptClient({onReady : this.clientLoaded});
    }

    clientLoaded(client){
        this.client = client;
        this.client.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
        if (this.props.hasOwnProperty("onReady")){
            this.props.onReady();
        }
    }

    getIdentity(callback, errorCallback){
        this.client.get(`identity`)
        .then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getAuditBatch(user, batch_size, filter_options, callback, errorCallback) {
      return this.client.post(`outfits/auditbatch`, {
          user: user,
          batch_size: batch_size,
          created_after: filter_options.after_date,
          created_before: filter_options.before_date,
          outfit_source: filter_options.outfit_source,
          marketplace_id: parseInt(filter_options.marketplace),
          seed_category: filter_options.seed_category
      }).then( function(response){
          callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
          errorCallback(error);
        }
      });
  }

    cancelAudit(user, callback){
      return this.client.post(`outfits/auditbatch/cancel`, {
        user: user
      })
      .then( function(response){
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }

    postAudit(audits, history, callback, errorCallback){
      return this.client.post(`outfits/audits`, {
        audit_history: history,
        audits: audits
      })
      .then(function(response){
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
         errorCallback(error);
        }
      });
    }

    postReAudit(audit, errorCallback){
      console.log("posting")
      return this.client.post(`reAudit`, {
        audits: audit
      })
      .catch(function (error) {
        console.log(error);
        if (errorCallback) {
         errorCallback(error);
        }
      });
    }

    getOutfits(filter_options, callback, errorCallback){

      return this.client.get(`outfits?&audited_after=${encodeURIComponent(encodeURIComponent(filter_options.after_date))}&audited_before=${encodeURIComponent(encodeURIComponent(filter_options.before_date))}\
&audit_status=${filter_options.audit_status}&next_token=${encodeURIComponent(encodeURIComponent(filter_options.next_token))}\
&outfit_source=${filter_options.outfit_source}&user=${filter_options.user}&marketplace_id=${parseInt(filter_options.marketplace)}\
&seed_category=${filter_options.seed_category}`
      )
      .then( function(response){
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
         errorCallback(error);
        }
      });
    }

    getOutfit(filter_options, callback, errorCallback){
      return this.client.get(`outfit?&outfit_id=${filter_options.outfit_id}`
      )
      .then( function(response){
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
         errorCallback(error);
        }
      });
    }

    getUserMetrics(filter_options, callback, errorCallback) {
      var after_date = encodeURIComponent(filter_options.after_date);
      var before_date = encodeURIComponent(filter_options.before_date);
      return this.client.get(encodeURI(`userAuditedBatchMetrics?&start_date=${after_date}&end_date=${before_date}\
&marketplace_id=${parseInt(filter_options.marketplace)}`)
      )
      .then(function(response){
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
         errorCallback(error);
        }
      });
    }
}



// WEBPACK FOOTER //
// ./src/components/common.jsx